import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { type AccountPersonalisationProps } from '@cx-shared/account-personalisation';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

const LazyAccountPersonalisation = lazy(() =>
	import('@cx-shared/account-personalisation').then(module => ({
		default: module.AccountPersonalisation,
	})),
);

export const AccountPersonalisation = (props: AccountPersonalisationProps) => (
	<ErrorBoundary
		fallbackRender={({ error }) => {
			captureRemixErrorBoundaryError(error);
			return null;
		}}
	>
		<Suspense fallback={<div>Error at AccountPersonalisation</div>}>
			<LazyAccountPersonalisation {...props} />
		</Suspense>
	</ErrorBoundary>
);
